import { Any, Obj, Arr, Str, Locale, Event } from "@kizmann/pico-js";
import AppService from "#pub/service/AppService.js";

export default {

    name: 'CrudIndex',

    title: Locale.trans('Index'),

    crud: {
        // index: '...', edit: '...',
    },

    urls: {
        // index: '...', item: '...',
    },

    search: [
        // 'field_name'
    ],

    filter: [
        //'token'
    ],

    columns: [
        {
            type: 'string',
            prop: 'id',
            label: Locale.trans('ID'),
            visible: false,
            minWidth: 0,
            fixedWidth: 320,
        },
        {
            type: 'datetime',
            prop: 'updated_at',
            label: Locale.trans('Updated'),
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
        {
            type: 'datetime',
            prop: 'created_at',
            label: Locale.trans('Created'),
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
    ],

    provide()
    {
        return {
            CrudIndex: this
        };
    },

    props: {

        deleteText: {
            default()
            {
                return 'Do you want to delete one item?|Do you want to delete :count items';
            },
            type: [String]
        }

    },

    data()
    {
        let paginate = {
            page: 1, limit: 500, total: 0
        };

        let sort = this.ctor('sort', [
            'created_at', 'desc'
        ]);

        let query = {
            token_id: null
        };

        let form = Obj.has(this.$route,
            'params.id');

        return {
            load: true, search: '', selected: [], data: [], form, sort, ...query, ...paginate
        };
    },

    computed: {

        count()
        {
            return this.selected.length;
        }

    },

    mounted()
    {
        Event.bind('xhr.success', (apx) => {
            this.checkXhrUpdate(apx);
        }, { uid: this._.uid });

        this.fetchItems();
    },

    watch: {

        '$route.params.id': function (val) {
            this.form = !!val;
        },

        'page': function () {
            this.fetchItems();
        },

        'limit': function () {
            this.fetchItems();
        },

        'token_id': function () {
            this.fetchItems();
        }

    },

    methods: {

        checkXhrUpdate(apx)
        {
            if ( Any.isEmpty(apx) ) {
                apx = ['no', 'no'];
            }

            if ( apx[0] !== this.ctor('name') ) {
                return;
            }

            let urls = [
                ...Any.vals(this.ctor('crud'))
            ];

            if ( ! Arr.has(urls, apx[1]) ) {
                return;
            }

            this.fetchItems();
        },

        gotoIndex()
        {
            let name = this.ctor('urls.index');

            if ( Any.isEmpty(name) ) {
                return;
            }

            this.$router.push({
                name
            });
        },

        gotoItem({ id })
        {
            let name = this.ctor('urls.item');

            if ( Any.isEmpty(name) ) {
                return;
            }

            this.$router.push({
                name, params: { id }
            });
        },

        getQuery()
        {
            let query = {
                limit: this.limit, page: this.page
            };

            if ( !Any.isEmpty(this.token_id) ) {
                query.token_id = this.token_id;
            }

            if ( !Any.isEmpty(this.sort) ) {
                query.sort = this.sort.join(',');
            }

            return query;
        },

        changeSort(sort)
        {
            this.sort = sort;

            this.fetchItems();
        },

        deleteConfirm()
        {
            let config = {
                text: this.choice(this.deleteText, this.count), type: 'danger',
            };

            this.Confirm.make(config)
                .then(() => {
                    this.deleteItems();
                });
        },

        fetchItems()
        {
            this.selected = [];

            let query = Obj.assign({}, {
                ...this.getQuery()
            });

            let config = {
                onLoad: () => this.load = true,
                onDone: () => this.load = false,
            };

            let url = AppService.queryUrl(this.ctor('crud.index'), {
                ...query
            });

            AppService.fetchData(url, config)
                .then(res => {
                    Arr.each(['data', 'page', 'total', 'limit'], (key) => {
                        this[key] = res.data[key];
                    });
                });
        },

        deleteItems()
        {
            let curl = this.ctor('crud.delete');

            let body = {
                ids: this.selected
            };

            let config = {
                onLoad: () => this.load = true,
                onDone: () => this.load = false,
            };

            let url = AppService.queryUrl(curl, {
                // Nothing
            });

            AppService.postData(url, body, config)
                .then(() => {
                    this.fetchItems();
                })
                .catch(() => {
                    this.fetchItems();
                });
        },

        filterItem(item)
        {
            if ( Any.isEmpty(this.search) ) {
                return true;
            }

            let [search, fields] = [
                Str.lower(this.search), this.ctor('search')
            ];

            let rainbow = Arr.each(fields, key => {
                return Str.lower(Obj.get(item, key)).indexOf(search) !== - 1;
            });

            return Arr.has(rainbow, true);
        },

    },

    renderActionCreate()
    {
        if ( !this.ctor('crud.create') ) {
            return null;
        }

        let createProps = {
            icon: 'fa fa-edit'
        };

        createProps['onClick'] = () => {
            this.form = true;
        };

        return (
            <NButton {...createProps}>
                {this.trans('New')}
            </NButton>
        );
    },

    renderActionDelete()
    {
        let url = this.ctor('crud.delete');

        if ( !url || !this.count ) {
            return null;
        }

        let deleteProps = {
            type: 'danger',
            glass: true,
            link: true,
        };

        deleteProps['onClick'] = () => {
            this.deleteConfirm();
        };

        return (
            <NButton {...deleteProps}>
                {this.trans('Delete')}
            </NButton>
        );
    },

    renderActionRefresh()
    {
        let refreshProps = {
            glass: true,
            icon: 'fa fa-sync'
        };

        refreshProps['onClick'] = () => {
            this.fetchItems();
        };

        return (
            <NButton {...refreshProps}>
                {this.trans('Refresh')}
            </NButton>
        );
    },

    renderAction()
    {
        return [
            this.ctor('renderActionDelete')(),
            this.ctor('renderActionRefresh')(),
            this.ctor('renderActionCreate')(),
        ];
    },

    renderFilterToken()
    {
        let tokenProps = {
            style: 'width: 220px',
            clearable: true,
            options: this.$root.tokens,
            optionsValue: '$value.id',
            optionsLabel: '$value.client',
            placeholder: this.trans('Only show client')
        };

        return (
            <NSelect vModel={this.token_id} {...tokenProps} />
        );
    },

    renderFilter()
    {

        return Arr.each(this.ctor('filter'), (filter) => {
            return this.ctor(`renderFilter${Str.ucfirst(filter)}`)();
        });
    },

    renderHeader()
    {
        let headerProps = {
            title: this.ctor('title'), search: this.search
        };

        headerProps['onUpdate:search'] = (value) => {
            this.search = value;
        };

        let slots = {
            filter: this.ctor('renderFilter'),
            action: this.ctor('renderAction'),
        };

        return (
            <AppHeader {...headerProps} v-slots={slots} />
        );
    },

    renderTable()
    {
        let items = Arr.filter(this.data, item => {
            return this.filterItem(item);
        });

        let tableProps = {
            items: items,
            selected: this.selected,
            sortProp: this.sort[0],
            sortDir: this.sort[1],
            itemHeight: 42,
            allowDrag: false,
            useKeys: false,
            renderCurrent: false,
            scrollTopOnChange: true,
        };

        tableProps['onUpdate:selected'] = (selected) => {
            this.selected = selected;
        };

        tableProps['onSort'] = (col, dir) => {
            this.changeSort([col, dir]);
        };

        tableProps['onRowDblclick'] = ({ item }) => {
            this.gotoItem(item);
        };

        return (
            <NTable {...tableProps}>
                {Arr.each(this.ctor('columns'), fx => <NTableColumn {...fx} />)}
            </NTable>
        );
    },

    renderPaginate()
    {
        let paginatorProps = {
            page: this.page, limit: this.limit, total: this.total
        };

        paginatorProps['onUpdate:page'] = (page) => {
            this.page = page;
        };

        paginatorProps['onUpdate:limit'] = (limit) => {
            this.limit = limit;
        };

        return (
            <NPaginator {...paginatorProps} />
        );
    },

    renderDrawer()
    {
        if ( !this.form ) {
            return null;
        }

        let drawerProps = {
            listen: true, width: '640px'
        };

        drawerProps['onUpdate:modelValue'] = (val) => {
            this.gotoIndex();
        };

        let slots = {
            raw: this.ctor('renderForm')
        };

        return (
            <NDrawer vModel={this.form} {...drawerProps} v-slots={slots} />
        );
    },

    renderForm()
    {
        console.error('Missing renderForm', this.ctor('name'));
    },

    render()
    {
        let ctors = [
            'renderHeader',
            'renderTable',
            'renderPaginate',
            'renderDrawer',
        ];

        return (
            <NLoader visible={this.load} class="app-view">
                {Arr.each(ctors, (fx) => this.ctor(fx)())}
            </NLoader>
        );
    }

}